import { useTranslation } from 'react-i18next';
import type { RouterOutputs } from '@/lib/trpc';
import { AmberNote } from './AmberNote';
import { CopyValue } from './CopyValue';

/** The values to copy into the store's Shopify Dev Dashboard app (`platform.getShopifyAppSetupValues`). */
export type ShopifyAppSetupValues = RouterOutputs['platform']['getShopifyAppSetupValues'];

/**
 * The Dev Dashboard values block (App URL, redirect URL, not embedded,
 * scopes), shared by the store page's Shopify card and Create Store, so the
 * platform admin can make the install link before or after registering.
 */
export function SetupValues({ setup }: { setup: ShopifyAppSetupValues }) {
  const { t } = useTranslation('settings');
  return (
    <div className="space-y-3 rounded-md border bg-muted/20 p-3">
      <p className="text-xs text-muted-foreground">{t('shopifyConnection.store.setup.description')}</p>
      {!setup.hostedPageReady && <AmberNote>{t('shopifyConnection.store.setup.notReady')}</AmberNote>}
      {setup.appUrl && <CopyValue label={t('shopifyConnection.store.setup.appUrl')} value={setup.appUrl} />}
      {setup.redirectUrl && <CopyValue label={t('shopifyConnection.store.setup.redirectUrl')} value={setup.redirectUrl} />}
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-xs font-medium text-muted-foreground">{t('shopifyConnection.store.setup.embedLabel')}</span>
        <span className="text-xs font-medium">{t('shopifyConnection.store.setup.embedOff')}</span>
      </div>
      <CopyValue label={t('shopifyConnection.store.setup.scopes')} value={setup.scopes.join(',')} />
    </div>
  );
}
